import { gql } from "@urql/core";

import { query } from "@/services/lukita";

export default function transactionsLocationsQuery({
  slug,
  accountId,
  channel,
}) {
  return query(
    gql`
      query TransactionsLocationsQuery(
        $slug: String!
        $accountId: ID!
        $channel: StatementTransactionPaymentChannels
      ) {
        project(slug: $slug, accountId: $accountId) {
          slug
          locations: transactionsLocations(channel: $channel) {
            location {
              lat
              lon
            }
          }
        }
      }
    `,
    {
      slug,
      accountId,
      channel,
    },
  );
}
